import { ReactElement } from 'react';
import { Component as WarningIcon } from 'icons/icon-circle--warning.svg';
import styles from 'platform/components/product-display-page/ProductDisplayPage.module.scss';

export function Alert(): ReactElement {
  return (
    <div className={styles.prospect_alert}>
      <WarningIcon height={20} width={20} />
      <div>This item isn&apos;t on this week&apos;s menu.</div>
    </div>
  );
}
